import React from 'react';
import { Link, routerShape } from 'react-router';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import sortBy from 'lodash/sortBy';

import { CAMINO_EVENTS_HE } from '../Authorization/constants';
import Header from '../../components/Header';
import Dropdown from '../../components/Dropdown';
import Menu from '../../components/Menu';
import Button from '../../components/Button';
import PageTitle from '../../components/PageTitle';
import FilterRow from './filter-row';
import messages from './messages';
import './styles.css';

class CollegeFiltersPage extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.shape({
      formatMessage: PropTypes.func.isRequired,
    }).isRequired,
    router: routerShape,
    viewer: PropTypes.object,
    renameCollegeEventFilter: PropTypes.func.isRequired,
    deleteCollegeEventFilter: PropTypes.func.isRequired,
    enabledFeatures: PropTypes.arrayOf(PropTypes.string),
  };

  constructor(props) {
    super(props);
    this.state = { sortField: 'publishedCollegeEventCount', isFirstInteraction: true };
  }

  onSortChange = (e, { value }) => {
    this.setState({ sortField: value, isFirstInteraction: false });
  };

  render() {
    const { intl, viewer, renameCollegeEventFilter, deleteCollegeEventFilter, enabledFeatures } = this.props;
    const { sortField } = this.state;

    const sortOptions = [
      { text: intl.formatMessage(messages.assignedTo), value: 'publishedCollegeEventCount', id: 'Number of live events assigned to' },
      { text: intl.formatMessage(messages.name), value: 'name', id: 'Name' },
      { text: intl.formatMessage(messages.recommendedTo), value: 'filterMatches', id: 'Number of students recommended to' },
    ];

    const trigger = (
      <div
        aria-hidden="true"
      >{sortOptions.find((option) => option.value === sortField).text}
      </div>
    );

    let filters = sortBy(viewer.eventFilters, sortField);
    /* istanbul ignore else */
    if (sortField !== 'name') {
      filters.reverse();
    } else {
      filters = sortBy(viewer.eventFilters, (event) => event.name.toUpperCase());
    }

    const headerKey = enabledFeatures.includes(CAMINO_EVENTS_HE) ? 'navianceHeader' : 'header';

    return (
      <div>
        <PageTitle subTitle="View Filters" title="Events" category="Intersect" />
        <Header style={{ paddingLeft: '0.6em' }} as="h1" color="black" size="large" id="pageTitle">
          <FormattedMessage {...messages[headerKey]} />
        </Header>
        <Menu secondary styleName="menu">
          <Menu.Menu position="right">
            <Menu.Item>
              <FormattedMessage {...messages.sortFiltersBy} />
              <Dropdown
                onOpen={this.onOpen}
                trigger={trigger}
                floating
                labeled
                button
                className="icon"
                styleName="sort-field"
                data-cy="college-events-filter-sort-dropdown"
                options={sortOptions}
                onChange={this.onSortChange}
                onFocus={() => this.setState({ isFirstInteraction: true })}
                aria-label={!this.state.isFirstInteraction ?
                  sortOptions.find((option) => option.value === sortField).id :
                  intl.formatMessage((messages.sortFiltersBy))}
              />
            </Menu.Item>
            <Menu.Item>
              <Button
                primary
                as={Link}
                to="/college-events/view-filters/create"
                data-cy="college-events-create-filter-button"
              >
                <FormattedMessage {...messages.create} />
              </Button>
            </Menu.Item>
          </Menu.Menu>
        </Menu>
        <div styleName="container">
          {filters.map((filter) =>
            (
              <FilterRow
                key={filter.id}
                filter={filter}
                renameCollegeEventFilter={renameCollegeEventFilter}
                deleteCollegeEventFilter={deleteCollegeEventFilter}
              />
            ))}
        </div>
      </div>
    );
  }
}

export default injectIntl(CollegeFiltersPage);
